import I18nHtml from './I18nHtml'

export default I18nHtml
